<div class="buttonlike-select-container" *ngIf="orgList != null && orgList.length > 1">
    <label>Org:</label>
    <select class="custom-select input-sm" [ngModel]="selectedOrg" (ngModelChange)="selectedOrgChanged($event)">
        <option *ngFor="let org of orgList; trackBy: 'id' | trackByProperty" [ngValue]="org">{{ org.name }}</option>
    </select>
</div>
